import { logError } from './log.js';

export const jsonParse = <T = unknown>(str: string): T => {
  try {
    if (typeof str === 'string') {
      return JSON.parse(str) as T;
    } else {
      return str;
    }
  } catch (e) {
    logError(`jsonParse error:`, e);
    return str as unknown as T;
  }
};
